export function getImagingScheduleOptions(imagingScheduleEntries, selectedSchedule) {
  const selectedEntries = [];
  for (let i = 0; i < imagingScheduleEntries.length; i++) {
    if (imagingScheduleEntries[i].id == selectedSchedule) {
      selectedEntries.push(imagingScheduleEntries[i]);
    }
  }
  const selectedEntriesWithUniqueRows = [];
  for (let i = 0; i < selectedEntries.length; i++) {
    const newEntry = {
      id: selectedEntries[i].id,
      cpName: selectedEntries[i].cpName,
      days: selectedEntries[i].days,
      hours: selectedEntries[i].hours,
      isSelected: selectedEntries[i].isSelected,
      entryId: selectedEntries[i].entryId,
    };
    selectedEntriesWithUniqueRows.push(newEntry);
  }
  return selectedEntriesWithUniqueRows;
}
